module.exports = __webpack_public_path__ + "static/media/publish-simultaneous-tablet-es.5e3ea592.webp";